module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content epos-box"
  }, [_c('div', {
    staticClass: "box box-info"
  }, [_c('div', {}, [_c('div', {
    staticClass: "p-fluid p-formgrid p-grid"
  }, [_c('div', {
    staticClass: "p-field p-col-12 p-lg-6 posItm lg-flex-order-2"
  }, [_c('DataView', {
    attrs: {
      "value": _vm.displayItemList,
      "paginator": true,
      "rows": 9,
      "layout": _vm.layout,
      "rowsPerPageOptions": [9, 100, 200]
    },
    scopedSlots: _vm._u([{
      key: "header",
      fn: function() {
        return [_c('div', {
          staticClass: "p-grid p-nogutter"
        }, [_c('div', {
          staticClass: "p-field p-col-12 radiobox"
        }, [_c('div', {
          staticClass: "radiobox-itm"
        }, [_c('RadioButton', {
          attrs: {
            "id": "barcode",
            "name": "Barcode",
            "value": "Barcode"
          },
          on: {
            "change": _vm.focusOnPageLoad
          },
          model: {
            value: (_vm.searchByBarcode),
            callback: function($$v) {
              _vm.searchByBarcode = $$v
            },
            expression: "searchByBarcode"
          }
        }), _vm._v(" "), _c('label', {
          staticClass: "p-mr-3",
          attrs: {
            "for": "barcode"
          }
        }, [_vm._v("Barcode")])], 1), _vm._v(" "), _c('div', {
          staticClass: "radiobox-itm"
        }, [_c('RadioButton', {
          attrs: {
            "id": "search",
            "name": "Search",
            "value": "Search"
          },
          on: {
            "change": _vm.focusOnPageLoad
          },
          model: {
            value: (_vm.searchByBarcode),
            callback: function($$v) {
              _vm.searchByBarcode = $$v
            },
            expression: "searchByBarcode"
          }
        }), _vm._v(" "), _c('label', {
          attrs: {
            "for": "search"
          }
        }, [_vm._v("Name")])], 1), _vm._v(" "), _c('div', {
          staticClass: "radiobox-itm"
        }, [_c('RadioButton', {
          attrs: {
            "id": "code",
            "name": "Item Code",
            "value": "Code"
          },
          on: {
            "change": _vm.focusOnPageLoad
          },
          model: {
            value: (_vm.searchByBarcode),
            callback: function($$v) {
              _vm.searchByBarcode = $$v
            },
            expression: "searchByBarcode"
          }
        }), _vm._v(" "), _c('label', {
          attrs: {
            "for": "code"
          }
        }, [_vm._v("Code")])], 1)]), _vm._v(" "), _c('InputText', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.searchByBarcode === 'Search'),
            expression: "searchByBarcode==='Search'"
          }],
          ref: "search",
          attrs: {
            "placeholder": "Please enter keyword"
          },
          on: {
            "input": _vm.searchItemWithUserInput
          },
          model: {
            value: (_vm.searchTerm),
            callback: function($$v) {
              _vm.searchTerm = $$v
            },
            expression: "searchTerm"
          }
        }), _vm._v(" "), _c('InputText', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.searchByBarcode === 'Barcode'),
            expression: "searchByBarcode === 'Barcode'"
          }],
          ref: "barcode",
          attrs: {
            "placeholder": "Barcode"
          },
          on: {
            "keypress": function($event) {
              if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
              return _vm.searchItem($event)
            }
          },
          model: {
            value: (_vm.searchTerm),
            callback: function($$v) {
              _vm.searchTerm = $$v
            },
            expression: "searchTerm"
          }
        }), _vm._v(" "), _c('InputText', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.searchByBarcode === 'Code'),
            expression: "searchByBarcode==='Code'"
          }],
          ref: "code",
          attrs: {
            "placeholder": "Please enter keyword"
          },
          on: {
            "input": _vm.searchItemWithUserInput
          },
          model: {
            value: (_vm.searchTerm),
            callback: function($$v) {
              _vm.searchTerm = $$v
            },
            expression: "searchTerm"
          }
        })], 1)]
      },
      proxy: true
    }, {
      key: "grid",
      fn: function(slotProps) {
        return [_c('div', {
          staticClass: "grid-item-col"
        }, [_c('div', {
          staticClass: "product-grid-item card"
        }, [_c('div', {
          staticClass: "product-grid-item-top"
        }, [_c('div', [_c('i', {
          staticClass: "pi pi-tag product-category-icon"
        }), _vm._v(" "), _c('span', {
          staticClass: "product-category"
        }, [_vm._v(_vm._s(slotProps.data.itemCode))])])]), _vm._v(" "), _c('div', {
          staticClass: "product-grid-item-content"
        }, [_c('a', {
          attrs: {
            "href": ""
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.displaySize(slotProps.data)
            }
          }
        }, [_c('img', {
          attrs: {
            "src": slotProps.data.singleImageUrl,
            "alt": slotProps.data.name
          }
        })]), _vm._v(" "), _c('div', {
          staticClass: "product-name"
        }, [_vm._v(_vm._s(slotProps.data.name))])]), _vm._v(" "), _c('div', {
          staticClass: "product-grid-item-bottom"
        }, [_c('span', {
          staticClass: "product-price"
        }, [_vm._v(_vm._s(slotProps.data.closingStock))]), _vm._v(" "), _c('Button', {
          staticClass: "p-button p-component p-button-icon-only",
          attrs: {
            "icon": "pi pi-shopping-cart"
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.displaySize(slotProps.data)
            }
          }
        })], 1)])])]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-lg-6 posItm lg-flex-order-1"
  }, [_c('DataTable', {
    staticClass: "editable-cells-table pos-table",
    attrs: {
      "value": _vm.salesItemList,
      "paginator": true,
      "rows": 25,
      "editMode": "cell",
      "paginatorTemplate": "CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown",
      "rowsPerPageOptions": [25, 50, 100],
      "currentPageReportTemplate": "Showing {first} to {last} of {totalRecords}"
    }
  }, [_c('Column', {
    attrs: {
      "header": "Item",
      "field": "itemName"
    },
    scopedSlots: _vm._u([{
      key: "footer",
      fn: function() {
        return [_vm._v("\n                  Total:\n                ")]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Qty",
      "field": "quantity",
      "bodyClass": "pos-table-quantity"
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function(slotProps) {
        return [_c('InputNumber', {
          staticStyle: {
            "width": "100%"
          },
          attrs: {
            "onfocus": "if (this.value === '0'){this.value = ''\n}",
            "showButtons": "",
            "buttonLayout": "horizontal",
            "decrementButtonClass": "p-button-danger",
            "incrementButtonClass": "p-button-success",
            "incrementButtonIcon": "pi pi-plus",
            "decrementButtonIcon": "pi pi-minus",
            "min": 0,
            "max": 100000
          },
          model: {
            value: (slotProps.data[slotProps.column.field]),
            callback: function($$v) {
              _vm.$set(slotProps.data, slotProps.column.field, $$v)
            },
            expression: "slotProps.data[slotProps.column.field]"
          }
        })]
      }
    }, {
      key: "footer",
      fn: function() {
        return [_vm._v("\n                  " + _vm._s(_vm.totalQuantity.toFixed(2)) + "\n                ")]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Rate",
      "field": "sellingPrice",
      "bodyClass": "pos-table-rate"
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function(slotProps) {
        return [(_vm.enableRateEdit) ? _c('InputNumber', {
          attrs: {
            "onfocus": "if (this.value === '0'){this.value = ''\n}",
            "minFractionDigits": 2,
            "maxFracionDigits": 4
          },
          model: {
            value: (slotProps.data.sellingPrice),
            callback: function($$v) {
              _vm.$set(slotProps.data, "sellingPrice", $$v)
            },
            expression: "slotProps.data.sellingPrice"
          }
        }) : _c('InputNumber', {
          attrs: {
            "disabled": "",
            "onfocus": "if (this.value === '0'){this.value = ''\n}",
            "minFractionDigits": 2,
            "maxFracionDigits": 4
          },
          model: {
            value: (slotProps.data.sellingPrice),
            callback: function($$v) {
              _vm.$set(slotProps.data, "sellingPrice", $$v)
            },
            expression: "slotProps.data.sellingPrice"
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Total",
      "bodyClass": "pos-table-total"
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function(slotProps) {
        return [_vm._v("\n                  " + _vm._s(slotProps.data.sellingPrice * slotProps.data.quantity) + "\n                ")]
      }
    }, {
      key: "footer",
      fn: function() {
        return [_vm._v("\n                  " + _vm._s(_vm.subTotal.toFixed(2)) + "\n                ")]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Action",
      "bodyClass": "pos-table-action"
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function(slotProps) {
        return [_c('Button', {
          staticClass: "p-button-rounded p-button-danger p-button-text",
          attrs: {
            "icon": "pi pi-trash"
          },
          on: {
            "click": function($event) {
              return _vm.removeItemFromList(slotProps.index, slotProps)
            }
          }
        })]
      }
    }])
  })], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    }
  }, [_vm._v(_vm._s(_vm.findTotalQuantity) + _vm._s(_vm.findDueAmt))]), _vm._v(" "), _c('Card', {
    staticClass: "p-mt-3 p-mb-3",
    scopedSlots: _vm._u([{
      key: "content",
      fn: function() {
        return [_c('div', {
          staticClass: "invoice-box"
        }, [_c('p', {
          staticClass: "invoice-ttl"
        }, [_vm._v("Total Quantity:")]), _vm._v(" "), _c('label', {}, [_vm._v(_vm._s(_vm.totalQuantity))])]), _vm._v(" "), _c('div', {
          staticClass: "invoice-box"
        }, [_c('p', {
          staticClass: "invoice-ttl",
          staticStyle: {
            "font-weight": "bold"
          }
        }, [_vm._v("Discount:")]), _vm._v(" "), _c('div', {
          staticClass: "invoice-col"
        }, [_c('div', {
          staticClass: "ivoice-btn"
        }, [(_vm.chooseDiscountAmt) ? _c('Button', {
          attrs: {
            "label": "Rs"
          },
          on: {
            "click": _vm.chooseDisountAmt
          }
        }) : _vm._e(), _vm._v(" "), (_vm.chooseDiscountPer) ? _c('Button', {
          attrs: {
            "label": "%"
          },
          on: {
            "click": _vm.chooseDisPercent
          }
        }) : _vm._e()], 1), _vm._v(" "), _c('div', {
          staticClass: "invoice-input"
        }, [(_vm.chooseDiscountAmt) ? _c('InputNumber', {
          attrs: {
            "onfocus": "if (this.value === '0'){this.value = ''\n    }",
            "placeholder": "Discount Amount"
          },
          model: {
            value: (_vm.discountAmt),
            callback: function($$v) {
              _vm.discountAmt = $$v
            },
            expression: "discountAmt"
          }
        }) : _vm._e(), _vm._v(" "), (_vm.chooseDiscountPer) ? _c('InputNumber', {
          attrs: {
            "onfocus": "if (this.value === '0'){this.value = ''\n    }",
            "placeholder": "Discount Per"
          },
          model: {
            value: (_vm.discountPer),
            callback: function($$v) {
              _vm.discountPer = $$v
            },
            expression: "discountPer"
          }
        }) : _vm._e()], 1)])]), _vm._v(" "), _c('div', {
          staticClass: "invoice-box"
        }, [_c('p', {
          staticClass: "invoice-ttl",
          staticStyle: {
            "font-weight": "bold"
          }
        }, [_vm._v("Discount Amt:")]), _c('label', {}, [_vm._v(_vm._s('Rs. ' + _vm.discountAmt))])]), _vm._v(" "), _c('div', {
          staticClass: "invoice-box"
        }, [_c('p', {
          staticClass: "invoice-ttl",
          staticStyle: {
            "font-weight": "bold"
          }
        }, [_vm._v("Sub Total:")]), _c('label', {}, [_vm._v(_vm._s('Rs. ' + _vm.subTotal))])]), _vm._v(" "), _c('div', {
          staticClass: "invoice-box"
        }, [_c('p', {
          staticClass: "invoice-ttl",
          staticStyle: {
            "font-weight": "bold"
          }
        }, [_vm._v("Total:")]), _c('label', {}, [_vm._v(_vm._s('Rs. ' + _vm.totalBillAmount))])])]
      },
      proxy: true
    }])
  }), _vm._v(" "), _c('div', {
    staticClass: "p-fluid p-formgrid p-grid"
  }, [_c('div', {
    staticClass: "p-field p-col-12 p-md-4"
  }, [_c('label', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("Contact Number:")]), _vm._v(" "), _c('InputText', {
    attrs: {
      "oninput": "this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\\..*?)\\..*/g, '$1').replace(/^0[^.]/, '0');",
      "id": "contactNum"
    },
    on: {
      "change": _vm.findPosCustomer
    },
    model: {
      value: (_vm.contactNumber),
      callback: function($$v) {
        _vm.contactNumber = $$v
      },
      expression: "contactNumber"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-4"
  }, [_c('label', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("Customer Name:")]), _vm._v(" "), _c('InputText', {
    model: {
      value: (_vm.customerName),
      callback: function($$v) {
        _vm.customerName = $$v
      },
      expression: "customerName"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-4"
  }, [_c('label', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("E-mail:")]), _vm._v(" "), _c('InputText', {
    model: {
      value: (_vm.email),
      callback: function($$v) {
        _vm.email = $$v
      },
      expression: "email"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('label', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v("Tender Amount:")]), _vm._v(" "), _c('InputNumber', {
    attrs: {
      "onfocus": "if (this.value === '0.00'){this.value = ''\n}",
      "mode": "decimal",
      "minFractionDigits": 2
    },
    model: {
      value: (_vm.tenderAmount),
      callback: function($$v) {
        _vm.tenderAmount = $$v
      },
      expression: "tenderAmount"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [(_vm.dueAmount < 0) ? _c('h4', [_vm._v("Return Amount: "), _c('b', {
    staticStyle: {
      "color": "red",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s('Rs. ' + _vm.dueAmount))])]) : _vm._e(), _vm._v(" "), (_vm.dueAmount > 0) ? _c('h4', [_vm._v("Return Amount: "), _c('b', {
    staticStyle: {
      "color": "green",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s('Rs. ' + _vm.dueAmount))])]) : _vm._e(), _vm._v(" "), (_vm.dueAmount === 0) ? _c('h4', [_vm._v("Return Amount: "), _c('b', {
    staticStyle: {
      "color": "grey",
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s('Rs. ' + _vm.dueAmount))])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('label', {
    staticStyle: {
      "font-weight": "bold"
    },
    attrs: {
      "for": "status1"
    }
  }, [_vm._v("Pay By:")]), _vm._v(" "), _c('div', {
    staticClass: "radiobox"
  }, [_c('div', {
    staticClass: "radiobox-itm"
  }, [_c('RadioButton', {
    attrs: {
      "id": "status1",
      "name": "Cash",
      "value": "CASH"
    },
    model: {
      value: (_vm.paymentMethod),
      callback: function($$v) {
        _vm.paymentMethod = $$v
      },
      expression: "paymentMethod"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "p-mr-3",
    attrs: {
      "for": "status1"
    }
  }, [_vm._v("Cash")])], 1), _vm._v(" "), _c('div', {
    staticClass: "radiobox-itm"
  }, [_c('RadioButton', {
    attrs: {
      "id": "status2",
      "name": "Esewa",
      "value": "ESEWA"
    },
    model: {
      value: (_vm.paymentMethod),
      callback: function($$v) {
        _vm.paymentMethod = $$v
      },
      expression: "paymentMethod"
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "status2"
    }
  }, [_vm._v("Esewa")])], 1), _vm._v(" "), _c('div', {
    staticClass: "radiobox-itm"
  }, [_c('RadioButton', {
    attrs: {
      "id": "status3",
      "name": "Fonepay",
      "value": "FONEPAY"
    },
    model: {
      value: (_vm.paymentMethod),
      callback: function($$v) {
        _vm.paymentMethod = $$v
      },
      expression: "paymentMethod"
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "status3"
    }
  }, [_vm._v("Fonepay")])], 1), _vm._v(" "), _c('div', {
    staticClass: "radiobox-itm"
  }, [_c('RadioButton', {
    attrs: {
      "id": "status4",
      "name": "Khalti",
      "value": "Khalti"
    },
    model: {
      value: (_vm.paymentMethod),
      callback: function($$v) {
        _vm.paymentMethod = $$v
      },
      expression: "paymentMethod"
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "status4"
    }
  }, [_vm._v("Khalti")])], 1), _vm._v(" "), _c('div', {
    staticClass: "radiobox-itm"
  }, [_c('RadioButton', {
    attrs: {
      "id": "status5",
      "name": "Bank",
      "value": "Bank"
    },
    model: {
      value: (_vm.paymentMethod),
      callback: function($$v) {
        _vm.paymentMethod = $$v
      },
      expression: "paymentMethod"
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "status5"
    }
  }, [_vm._v("Bank")])], 1), _vm._v(" "), _c('div', {
    staticClass: "radiobox-itm"
  }, [_c('RadioButton', {
    attrs: {
      "id": "status6",
      "name": "Ncm",
      "value": "Ncm"
    },
    model: {
      value: (_vm.paymentMethod),
      callback: function($$v) {
        _vm.paymentMethod = $$v
      },
      expression: "paymentMethod"
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "status6"
    }
  }, [_vm._v("Ncm")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('label', {
    staticStyle: {
      "font-weight": "bold"
    },
    attrs: {
      "for": "status1"
    }
  }, [_vm._v("Paid Status:")]), _vm._v(" "), _c('div', {
    staticClass: "radiobox"
  }, [_c('div', {
    staticClass: "radiobox-itm"
  }, [_c('RadioButton', {
    attrs: {
      "id": "status1",
      "name": "paid",
      "value": "PAID"
    },
    model: {
      value: (_vm.paymentStatus),
      callback: function($$v) {
        _vm.paymentStatus = $$v
      },
      expression: "paymentStatus"
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "p-mr-3",
    attrs: {
      "for": "status1"
    }
  }, [_vm._v("Paid")])], 1), _vm._v(" "), _c('div', {
    staticClass: "radiobox-itm"
  }, [_c('RadioButton', {
    attrs: {
      "id": "status2",
      "name": "unpaid",
      "value": "UNPAID"
    },
    model: {
      value: (_vm.paymentStatus),
      callback: function($$v) {
        _vm.paymentStatus = $$v
      },
      expression: "paymentStatus"
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "status2"
    }
  }, [_vm._v("Unpaid/Delivery")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('label', {
    staticStyle: {
      "font-weight": "bold"
    },
    attrs: {
      "for": "address"
    }
  }, [_vm._v("Address:")]), _vm._v(" "), _c('InputText', {
    attrs: {
      "id": "address"
    },
    model: {
      value: (_vm.address),
      callback: function($$v) {
        _vm.address = $$v
      },
      expression: "address"
    }
  })], 1), _vm._v(" "), (_vm.paymentStatus === 'UNPAID') ? _c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('label', {
    staticStyle: {
      "font-weight": "bold"
    },
    attrs: {
      "for": "delivery"
    }
  }, [_vm._v("Delivery Amount:")]), _vm._v(" "), _c('InputText', {
    attrs: {
      "id": "delivery"
    },
    model: {
      value: (_vm.deliveryCharge),
      callback: function($$v) {
        _vm.deliveryCharge = $$v
      },
      expression: "deliveryCharge"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-6"
  }, [_c('label', {
    staticStyle: {
      "font-weight": "bold"
    },
    attrs: {
      "for": "remarks"
    }
  }, [_vm._v("Remarks:")]), _vm._v(" "), _c('InputText', {
    attrs: {
      "id": "remarks"
    },
    model: {
      value: (_vm.remarks),
      callback: function($$v) {
        _vm.remarks = $$v
      },
      expression: "remarks"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "p-fluid p-formgrid p-grid"
  }, [_c('div', {
    staticClass: "p-field p-col-6 p-lg-4 p-xl-3"
  }, [_c('Button', {
    staticClass: "p-button p-component p-button-success",
    attrs: {
      "label": "Submit"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.savePOSEntry.apply(null, arguments)
      }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-6 p-lg-4 p-xl-3"
  }, [_c('Button', {
    staticClass: "p-button p-component p-button-danger",
    attrs: {
      "label": "Cancel"
    },
    on: {
      "click": function($event) {
        return _vm.$router.back()
      }
    }
  })], 1)])], 1)])])]), _vm._v(" "), _c('Dialog', {
    style: ({
      width: '35vw'
    }),
    attrs: {
      "visible": _vm.printDialog,
      "header": "Do you want to print this bill?",
      "modal": true,
      "closable": false
    },
    on: {
      "update:visible": function($event) {
        _vm.printDialog = $event
      }
    }
  }, [_c('div', {
    staticClass: "p-fluid p-formgrid p-grid p-mt-2"
  }, [_c('div', {
    staticClass: "p-field p-col-12 p-xl-2"
  }, [_c('Button', {
    staticClass: "p-button-raised p-button-rounded",
    attrs: {
      "label": "Yes",
      "icon": "pi pi-check"
    },
    on: {
      "click": _vm.printBill
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-xl-2"
  }, [_c('Button', {
    staticClass: "p-button-raised p-button-rounded p-button-danger",
    attrs: {
      "icon": "pi pi-times",
      "label": "No"
    },
    on: {
      "click": _vm.closePrintDialog
    }
  })], 1)])]), _vm._v(" "), _c('Dialog', {
    style: ({
      width: '35vw'
    }),
    attrs: {
      "visible": _vm.qotPrintDialog,
      "header": "Do you want to print this bill?",
      "modal": true,
      "closable": false
    },
    on: {
      "update:visible": function($event) {
        _vm.qotPrintDialog = $event
      }
    }
  }, [_c('div', {
    staticClass: "p-fluid p-formgrid p-grid p-mt-2"
  }, [_c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_c('Button', {
    staticClass: "p-button-raised p-button-rounded",
    attrs: {
      "label": "Yes",
      "icon": "pi pi-check"
    },
    on: {
      "click": _vm.printQOT
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "p-field p-col-12 p-md-2"
  }, [_c('Button', {
    staticClass: "p-button-raised p-button-rounded p-button-danger",
    attrs: {
      "icon": "pi pi-times",
      "label": "No"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.closePrintDialog.apply(null, arguments)
      }
    }
  })], 1)])]), _vm._v(" "), _c('Dialog', {
    style: ({
      width: '60vw',
      height: '20vw'
    }),
    attrs: {
      "header": "Size Details",
      "visible": _vm.displayBasic,
      "modal": true,
      "closable": true,
      "contentStyle": {
        'overflow': 'visible'
      }
    },
    on: {
      "update:visible": function($event) {
        _vm.displayBasic = $event
      }
    }
  }, [_c('DataTable', {
    attrs: {
      "value": _vm.inventorySizeDetailsDTOList,
      "paginator": true,
      "rows": 5
    }
  }, [_c('Column', {
    attrs: {
      "header": "Size",
      "field": "size",
      "bodyStyle": "width:25%"
    }
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Color",
      "field": "color",
      "bodyStyle": "width:25%"
    }
  }), _vm._v(" "), _c('Column', {
    attrs: {
      "header": "Avl Qty",
      "field": "quantity",
      "bodyStyle": "width:25%"
    }
  }), _vm._v(" "), _c('Column', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "header": "Qty",
      "field": "salesQty",
      "bodyStyle": "width:50%"
    },
    scopedSlots: _vm._u([{
      key: "body",
      fn: function(slotProps) {
        return [_c('InputNumber', {
          staticStyle: {
            "width": "3em"
          },
          attrs: {
            "onfocus": "if (this.value === '0'){this.value = ''}",
            "showButtons": "",
            "buttonLayout": "horizontal",
            "decrementButtonClass": "p-button-danger",
            "incrementButtonClass": "p-button-success",
            "incrementButtonIcon": "pi pi-plus",
            "decrementButtonIcon": "pi pi-minus",
            "min": 0,
            "max": 100000
          },
          model: {
            value: (slotProps.data[slotProps.column.field]),
            callback: function($$v) {
              _vm.$set(slotProps.data, slotProps.column.field, $$v)
            },
            expression: "slotProps.data[slotProps.column.field]"
          }
        })]
      }
    }])
  })], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticStyle: {
      "float": "right"
    }
  }, [_c('Button', {
    staticClass: "p-button-raised p-button-rounded p-button-success",
    attrs: {
      "label": "Add"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.addItemToList(_vm.salesData)
      }
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3767d149"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/pos/posEntry.vue
// module id = 2151
// module chunks = 0